import { API, identityServiceUrl } from '@labrav/common'
import type {
  AccountDataSelection,
  CloudType,
  ProductType,
} from '@labrav/common'

export const createCloudAccount = (data: Partial<AccountDataSelection>) => {
  const updatedData = {
    ...data,
    product: data?.product?.toUpperCase() || 'FLYOUT',
  }
  return API.post(`${identityServiceUrl}/accounts`, updatedData)
}

export const getCloudAccounts = (partnerId: string) => {
  const params = new URLSearchParams({ partner_id: partnerId })
  return API.get(`${identityServiceUrl}/accounts?${params.toString()}`)
}

export const deleteCloudAccountByCloudAndProduct = (
  accountId: string,
  cloudType: CloudType | string,
  productType: ProductType | string
) => {
  return API.delete(
    `${identityServiceUrl}/accounts/${accountId}/cloud/${cloudType}/product/${productType}`
  )
}
